module.exports = __webpack_public_path__ + "static/img/IMG_20151026_113539.fe6b1cca.jpg";